import { standaloneLessonsSelCompetencies } from "@constants";
import { MIXPANEL_NONE } from "@src/constants/analyticsTracking";

const KNOWN_COMPETENCIES = new Set(
  standaloneLessonsSelCompetencies.map((opt) => opt.value),
);

/**
 * Parses SuperAdmin Competency field (JSON array string or plain string)
 * into Mixpanel-ready labels matching `standaloneLessonsSelCompetencies`.
 */
export const resolveMixpanelCompetencies = (
  competency?: string | null,
): string[] => {
  if (!competency?.trim()) return [];

  let values: string[] = [];
  try {
    const parsed = JSON.parse(competency);
    if (Array.isArray(parsed)) {
      values = parsed.map((v) => String(v ?? "").trim()).filter(Boolean);
    } else if (parsed != null && String(parsed).trim()) {
      values = [String(parsed).trim()];
    }
  } catch {
    values = competency
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
  }

  // Prefer known SuperAdmin labels; still keep unknowns so data isn't dropped
  return values.map((v) => {
    if (KNOWN_COMPETENCIES.has(v)) return v;
    const match = standaloneLessonsSelCompetencies.find(
      (opt) => opt.label === v || opt.value === v,
    );
    return match?.value ?? v;
  });
};

/** Always include competency — "None" when unknown (avoids Mixpanel "(not set)"). */
export const mixpanelCompetencyProps = (
  competency?: string | null,
): { competency: string[] } => {
  const values = resolveMixpanelCompetencies(competency);
  return { competency: values.length ? values : [MIXPANEL_NONE] };
};
